
import {
  Employee,
  Location,
  Concept as ConceptService,
  Integrations as IntegrationService, Location as LocationService, Subscription as SubscriptionApi,
} from '@/services/SOLO';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { translations } from '@/mixins';
import { mapGetters } from 'vuex';

// let Locations = new LocationService();

interface DeliveryZone {
  coordinates: number[][];
  id: string;
  label: string;
  deliveryCharge: number | null | string;
  minimumOrderAmount: number | null | string;
  code?: number | null | string;
}

@Component({
  mixins: [translations],
  computed: {
    ...mapGetters({
      getConceptSettings: 'account/getConceptSettings',
      getLocale: 'app/getLocale',
    }),
  },
})

export default class LocationDeliveryZone extends Vue {
  @Prop() locationId!: string;
  @Prop() hasOcimsIntegration!: any;
  $notify: any;
  getConceptSettings!: any;
  private isOverrideDeliveryCharges = false;
  private deliveryZones: DeliveryZone[] = [];
  private isSaving = false;
  private saveButtonText = '';
  translate!: Function;

  mounted () {
    this.saveButtonText = this.translate('SAVE') as string;
    this.fetchDeliveryZones();
    console.log('hasOcimsIntegration2', this.hasOcimsIntegration);
  }

  async fetchDeliveryZones (page = 1, size = 15) {
    try {
      const response = await Location.deliveryAreas(this.locationId, page, size);
      const deliveryAreas = response.data.data;
      const zones = deliveryAreas.map((area: any) => {
        const areaId = area.id;

        const items = {
          id: areaId,
          label: area.attributes.label,
          deliveryCharge: area.attributes['delivery-charge'] === '' ? null : (area.attributes['delivery-charge'] === 0 ? 0 : area.attributes['delivery-charge']),
          minimumOrderAmount: area.attributes['minimum-order-amount'] === '' ? null : (area.attributes['minimum-order-amount'] === 0 ? 0 : area.attributes['minimum-order-amount']),
          coordinates: area.attributes.coordinates,
          code: area.attributes.code,
        };

        return items;
      });

      this.deliveryZones = [...this.deliveryZones, ...zones];

      if (
        response.data.meta.pagination.current_page <
        response.data.meta.pagination.total_pages
      ) {
        this.fetchDeliveryZones(response.data.meta.pagination.current_page + 1);
      }
    } catch (error) {
      console.error('Error fetching delivery zones:', error);
    }
  }

  async saveDeliveryZoneSettings () {
  // Change the button text to "SAVING"
    this.saveButtonText = this.translate('SAVING');

    // Disable the button during the save operation
    this.isSaving = true;

    try {
    // Retrieve the updated delivery zones data
      const updatedDeliveryZones: DeliveryZone[] = this.deliveryZones.map((zone) => ({
        ...zone,
        deliveryCharge: zone.deliveryCharge === '' ? null : (zone.deliveryCharge === 0 ? 0 : Number(zone.deliveryCharge)),
        minimumOrderAmount: zone.minimumOrderAmount === '' ? null : (zone.minimumOrderAmount === 0 ? 0 : Number(zone.minimumOrderAmount)),
        code: zone.code,
      }));

      // Update each delivery zone
      for (const zone of updatedDeliveryZones) {
        const coordinates = zone.coordinates;

        if (coordinates[0][0] != coordinates[coordinates.length - 1][0] && coordinates[0][1] != coordinates[coordinates.length - 1][1]) {
          coordinates.push(coordinates[0]);
        }

        // Prepare the payload for the update
        const payload = {
          label: zone.label,
          'delivery-charge': zone.deliveryCharge,
          'minimum-order-amount': zone.minimumOrderAmount,
          coordinates: coordinates,
          code: zone.code,
        };

        // Make the API call to update the delivery area
        await Location.updateDeliveryArea(
          payload,
          this.locationId,
          zone.id);
      }

      // Show success toast with translated message
      this.$notify({
        title: this.translate('RECORDS SAVED!'),
        verticalAlign: 'bottom',
        horizontalAlign: 'left',
        message: this.translate('Delivery Zone settings saved successfully'),
        type: 'success',
        icon: 'fas fa-check',
      });

      // Reset the checkbox state to false
      this.isOverrideDeliveryCharges = false;
    } catch (error) {
      console.error('Error saving delivery zone settings:', error);
      this.$notify({
        title: 'ERROR SAVING DELIVERY CHARGES',
        verticalAlign: 'bottom',
        horizontalAlign: 'left',
        message: error.response.data.messages?.code[0] || error.response.data.error[0]?.detail,
        type: 'danger',
        icon: 'fas fa-bomb',
      });
    } finally {
    // Enable the button after the save operation is completed
      this.isSaving = false;

      // Restore the original button text
      this.saveButtonText = this.translate('SAVE');
    }
  }

  private cancelPopup () {
    this.$emit('location:cancel');
  }

  get deliveryZoneFields (): any[] {
    const currencyCode = this.currencyCode;
    const fields = [
      { key: 'label', label: this.translate('Delivery Zone') },
      { key: 'delivery-charge', label: `${this.translate('Delivery Charge')} (${currencyCode})` },
      { key: 'minimum-order-amount', label: `${this.translate('Minimum Order')} (${currencyCode})` },
    ];

    if (this.hasOcimsIntegration) {
      fields.push({ key: 'zone-unique-id', label: this.translate('Zone Unique ID') });
    }

    return fields;
  }

  get currencyCode (): string {
    if (this.getConceptSettings && this.getConceptSettings.attributes) {
      return this.$displayCurrency(this.getConceptSettings.attributes['currency-code']);
    }
    return ''; // Return an empty string or a default value if the object is undefined or properties are missing
  }

  @Watch('isOverrideDeliveryCharges')
  onOverrideDeliveryChargesChange (newVal: boolean): void {
    if (newVal) {
      // Checkbox is checked, set the value of isOverrideDeliveryCharges to true
      this.isOverrideDeliveryCharges = true;
    }
  }
}
